import { render } from "./ModulAccordion.vue?vue&type=template&id=271ad0a0"
import script from "./ModulAccordion.vue?vue&type=script&lang=js"
export * from "./ModulAccordion.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__